import React from 'react';
import './Glare.css';

const Glare = () => {
    return <div className="glare-effect"></div>;
};

export default Glare;
